/**
 * PeriodSegment — сегмент-контрол периода метрик: День / Неделя / Месяц +
 * «Период» (свой диапазон). «Период» открывает общий PeriodPicker
 * (десктоп — дравер, мобилка — bottom-sheet).
 */

import {useState} from 'react';

import {PeriodPicker} from '@components/PeriodPicker';
import {cn} from '@lib/utils';

import {DASH_SEGMENTS, type DashPeriod, dashRangeLabel} from '../Dashboard.utils';

type PeriodSegmentProps = {period: DashPeriod; onChange: (p: DashPeriod) => void; mobile?: boolean};

const SEG = 'flex-1 rounded-[7px] px-3 py-1.5 text-center text-[12.5px] transition-colors';
const SEG_ON = 'bg-card font-semibold text-foreground shadow-[0_1px_2px_rgba(0,0,0,.07)]';
const SEG_OFF = 'font-medium text-muted-foreground';

export const PeriodSegment = ({period, onChange, mobile = false}: PeriodSegmentProps) => {
  const [open, setOpen] = useState(false);
  const isRange = typeof period !== 'string';

  return (
    <div className="flex gap-[2px] rounded-[9px] bg-[#E9EAEE] p-[3px]">
      {DASH_SEGMENTS.map((s) => (
        <button
          key={s.key}
          onClick={() => onChange(s.key)}
          className={cn(SEG, period === s.key ? SEG_ON : SEG_OFF)}
        >
          {s.label}
        </button>
      ))}
      <button
        onClick={() => setOpen(true)}
        className={cn(SEG, 'whitespace-nowrap', isRange ? SEG_ON : SEG_OFF)}
      >
        {dashRangeLabel(period)}
      </button>

      <PeriodPicker
        open={open}
        onOpenChange={setOpen}
        mobile={mobile}
        value={isRange ? period : null}
        onApply={onChange}
      />
    </div>
  );
};
